import React from 'react'
import style from './style.css'

export default props => (
    <div
        className={`${style.scroll} ${props.floating ? style.floating : ''} ${props.className || ''} ${style[props.styleName || '']}`}
        style={{
            ...props.style,

            maxHeight: props.height || null,
        }}
        >
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/BoxScroll/index.js